import Vue from "vue";
import Router from "vue-router";
import GameList from "./components/home/GameList.vue";
import Scoresheet from "./components/scoresheet/Scoresheet.vue";
import NewGame from "./components/game-selection/NewGame.vue";
import store from './store/';
import LoginPage from './components/login/LoginPage'
import RegisterPage from './components/register/RegisterPage'
import BuildRoster from './components/game-selection/BuildRoster'

Vue.use(Router);
 
const router = new Router({
  mode: "history",
  store,
  routes: [
    {
      path: "/games",
      name: "games",
      component: GameList,
    },
    {
      path: "/games/:id",
      name: "game-details",
      component: Scoresheet
    },
    {
      path: "/",
      name: "newgame",
      alias: '/new-game',
      component: NewGame,
    },
    {
      path: "/roster",
      name: "roster",
      alias: '/roster',
      component: BuildRoster,
    },
    { path: '/login', name: 'login', component: LoginPage },
    { path: '/register', component: RegisterPage },
    { path: '*', redirect: '/' }
  ]
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login', '/register', '/'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  if (authRequired && !loggedIn) {
    return next({name: 'login', query: { redirect: to.name}, params: to.params });
  }

  next();
})

export default router;